//
//
//
//
//
//
//
//
//
//

import { queryOpenIdentify } from '@/https/user'
import TIdentifyAttachmentFile from './TIdentifyAttachmentFile'

export default {
  components: { TIdentifyAttachmentFile },

  created () {
    this.queryConfig()
  },

  methods: {
    async queryConfig () {
      const { code, data } = await queryOpenIdentify()

      if (+data !== 1 && +code === 0) {
        this.$refs.check.submit()
      }
    },
  },
}
